<script setup lang="ts">
import { Link, usePage } from '@inertiajs/vue3';
import { LogOut, UserRound } from 'lucide-vue-next';
import { computed } from 'vue';
import { Button } from '@/components/ui/button';
import { useI18n } from '@/composables/useI18n';

const { __ } = useI18n();

const page = usePage();
const user = computed(() => page.props.auth?.user);

const isImpersonating = computed(() => user.value?.is_impersonating === true);
const impersonator = computed(() => user.value?.impersonator ?? null);
</script>

<template>
    <div
        v-if="isImpersonating"
        data-test="impersonation-banner"
        class="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 border-b border-amber-300/60 bg-amber-100 px-4 py-2 text-center dark:border-amber-500/30 dark:bg-amber-950/60"
    >
        <span
            class="flex items-center gap-2 text-sm font-medium text-amber-900 dark:text-amber-200"
        >
            <UserRound class="h-4 w-4 shrink-0" />
            <span
                v-html="
                    __('impersonation.banner', {
                        name: user?.name ?? '',
                        impersonator: impersonator?.name ?? '',
                    })
                "
            ></span>
        </span>

        <Button
            variant="outline"
            size="sm"
            as-child
            class="border-amber-400 bg-transparent text-amber-900 hover:bg-amber-200/60 dark:border-amber-500/50 dark:text-amber-100 dark:hover:bg-amber-900/40"
        >
            <!-- Route package lab404/laravel-impersonate : /impersonate/leave -->
            <Link href="/impersonate/leave" data-test="leave-impersonation">
                <LogOut class="mr-1.5 h-3.5 w-3.5" />
                {{ __('impersonation.leave') }}
            </Link>
        </Button>
    </div>
</template>
